
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.656 3c-.828 0-1.219.438-1.687.875-.469.438-.918.98-1.344 1.594-.129.183-.254.37-.375.562a8.874 8.874 0 00-.594-1.218c-.68-1.141-1.437-1.75-1.437-1.75l-1.25 1.562s.449.348.969 1.219C5.457 6.714 6 8.054 6 10v13h2V10c0-.184-.023-.355-.031-.531H8c0-.469.535-1.84 1.25-2.875.36-.52.742-.985 1.063-1.282.117-.109.226-.171.312-.218.078.047.18.11.281.218.293.32.645.829.969 1.375.324.547.605 1.168.813 1.688.207.52.312.984.312 1.094V23h2V9.469c0-.528.488-1.875 1.125-2.906.32-.516.652-.993.938-1.282.09-.093.175-.144.25-.187.09.05.21.117.343.25.324.328.7.855 1.063 1.406.363.55.707 1.137.937 1.656.23.52.344.992.344 1.063v10.25c0 1.87.855 3.547 1.938 4.937C20.808 25.473 19.261 26 17 26v2c2.688 0 4.762-.742 6.281-1.875.078.078.14.176.219.25a22.541 22.541 0 003.344 2.688l1.062-1.688s-1.523-.93-3.031-2.406c-.059-.055-.102-.13-.156-.188.172-.207.32-.437.468-.656C26.652 21.93 27 19.335 27 17.344c0-1.899-.469-3.426-1.125-4.5C25.219 11.77 24.445 11 23.312 11c-.652 0-1.015.305-1.312.656V9.47c0-.664-.21-1.23-.5-1.875a14.3 14.3 0 00-1.094-1.969 11.432 11.432 0 00-1.343-1.688c-.461-.468-.83-.938-1.72-.938-.827 0-1.245.43-1.687.875a9.28 9.28 0 00-1.25 1.625c-.164.27-.32.531-.469.813-.113-.208-.222-.422-.343-.625-.375-.637-.785-1.243-1.219-1.72-.434-.476-.828-.968-1.719-.968zm12.75 10.094c-.039.035.356.164.75.812.442.723.844 1.871.844 3.438 0 1.742-.367 3.988-1.5 5.687-.04.063-.082.13-.125.188-.805-1.125-1.375-2.356-1.375-3.5V17c0-.598.3-1.793.719-2.719.207-.46.441-.89.625-1.125.031-.043.035-.039.062-.062z"}})])
          )
        }
      }
    